import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import FeatureForTeamsContent from '../components/FeatureForTeams/FeatureForTeamsContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../redux/language/selector'

const FeatureForTeams = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('features-for-teams-page.features-for-teams-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
      <NavbarTop />
      <FeatureForTeamsContent />
      
    </>
  )
}

export default FeatureForTeams